export interface NavLink {
    url: string;
    string: string;
}

export const navbarLinks: NavLink[] = [
    { url: '/home', string: "home" },
    { url: '/more_parts', string: "moreParts" },
    { url: '/subscription', string: "beAdvertiser" },
];